<template>
  <div>
    <el-card class="search-query mb10">
      <el-form label-position="top" size="small">
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item label="运单号">
              <template slot="label">
                <el-select v-model="queryForm.params.orderType" class="select-label" style="width: 260px;">
                  <el-option key="1" :label="$t('collectionCenter.waybillNumber')" :value="1" />
                  <el-option key="2" :label="$t('collectionCenter.ScanNumber')" :value="2" />
                </el-select>
              </template>
              <el-input
                v-model="queryForm.params.orderNo" type="textarea" :rows="5"
                :placeholder="$t('collectionCenter.pleaseInput')" clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('collectionCenter.orderCreateT')">
              <el-date-picker
                v-model="queryForm.params.createTime"
                type="datetimerange"
                range-separator="-"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00', '23:59:59']"
                :start-placeholder="$t('GlobalSetObj.startDate')"
                :end-placeholder="$t('GlobalSetObj.endDate')"
                style="width: 100%;"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <!--客户-->
            <el-form-item
              :label="$t('orderCenterCont.customer')"
              prop="region"
              style="width: 100%"
            >
              <el-select
                v-model="queryForm.params.customerIds"
                :placeholder="$t('operationCenter.PleaseSelect')"
                clearable
                filterable
                multiple
                style="width: 100%"
                remote
                reserve-keyword
                :remote-method="getUserOption"
                @visible-change="userOptionVisible"
              >
                <el-option
                  v-for="(item, index) in customerList"
                  :key="index"
                  :label="item.customerAlias + '（' + item.username + '）'"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <!--商户-->
            <el-form-item :label="$t('placeOrder.CommercialOwner')">
              <el-select
                v-model="queryForm.params.merchantCodeList"
                :placeholder="$t('placeOrder.pleaseChoose')"
                :remote-method="getShanghu"
                clearable
                filterable
                multiple
                remote
                reserve-keyword
                style="width: 100%"
                @visible-change="getShanghuVisible"
              >
                <el-option
                  v-for="item in commercialList"
                  :key="item.id"
                  :label="item.merchantName"
                  :value="item.merchantCode"
                >
                  <div>
                    <span>{{ item.merchantName }}（{{ item.merchantCode }}）</span>
                  </div>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <div style="margin-top: 28px;">
              <el-radio-group
                v-model="queryForm.params.testData"
                size="small"
                style="margin: 0 10px"
                @change="clickSearch"
              >
                <el-radio-button :label="1">{{ $t('newOrder.Formal') }}</el-radio-button>
                <el-radio-button :label="2">{{ $t('newOrder.test1') }}</el-radio-button>
              </el-radio-group>
              <!--搜索-->
              <el-button
                size="small" type="primary" @click="clickSearch"
              >{{ $t('newOrder.search') }}
              </el-button>
              <!--重置-->
              <el-button
                size="small" type="info" @click="resetForm"
              >{{ $t('newOrder.reset') }}
              </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card>
      <div style="margin-bottom: 10px;">
        <el-button
          size="small" type="primary" @click="exportExcel"
        >{{ $t('newOrder.export') }}
        </el-button>
      </div>
      <el-table
        :data="tableData"
        border
        class="table-height"
        :header-cell-style="{background:'#f2f2f2',color:'black'}"
        :height="tableHeightRow.height"
      >
        <el-table-column
          :label="$t('GlobalSetObj.serial')" align="center" type="index"
          fixed="left"
          width="80"
        />
        <el-table-column
          v-for="item in tableHeaderList"
          :key="item.id"
          :align="item.center"
          :label="item.label"
          :min-width="item.minWidth"
          :prop="item.prop"
        >
          <template slot-scope="scope">
            <div v-if="item.prop === 'status'">
              <!--'已生成'-->
              <el-tag v-if="scope.row.status === 1" size="mini" type="success">{{ $t('mdfeTranslate.Authorized') }}</el-tag>
              <!--已取消-->
              <el-tag v-else-if="scope.row.status === 2" size="mini" type="info">{{ $t('GlobalSetObj.Canceled') }}</el-tag>
              <!--已关闭-->
              <el-tag v-else-if="scope.row.status === 3" size="mini" type="danger">{{ $t('mdfeTranslate.Closed') }}</el-tag>
            </div>
            <div v-else-if="item.prop === 'waybillNumber'">
              <span style="cursor: pointer;color: #00A551;font-weight: bold;" @click="goWaybill(scope.row)">{{ scope.row.waybillNumber }}</span>
            </div>
            <div v-else>
              {{ scope.row[item.prop] }}
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页工具 -->
      <div class="pagination">
        <el-pagination
          :current-page.sync="queryForm.pageNumber"
          :page-size.sync="queryForm.pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="queryForm.total"
          background
          layout="total, sizes, prev, pager, next, jumper"
          style="margin: 10px 0"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </el-card>
    <!--轨迹-->
    <el-drawer
      :append-to-body="true"
      :title="$t('orderCenterCont.TrajectoryQuery')"
      :visible.sync="showTrajectoryWindow"
      custom-class="drawerClass"
      direction="ltr"
      size="90%"
    >
      <div style="height: calc(100vh - 67px); overflow: auto">
        <trackQuery :key="trajectoryKey" :query-track-param="queryTrackParam" query-type="2" />
      </div>
    </el-drawer>
  </div>
</template>
<script>
import { apiCustomerPage } from '@/api/customer';
import { apiGetComplaintGetMerchantName } from '@/api/newExpressAPI';
import dayjs from 'dayjs';
import estimateTableHeight from '@/views/finance/mixins/estimateTableHeight.js';
import { getTrackOverdueExport, getTrackOverdueList } from '@/api/orderApi';
import { goResourceTaskList } from '@/utils/goExportList';
const startDate = dayjs().subtract(29, 'day').format('YYYY-MM-DD HH:mm:ss'); // 30 天前
const endDate = dayjs().format('YYYY-MM-DD HH:mm:ss'); // 今天
export default {
  name: 'OrderCreateTime',
  components: {
    'trackQuery': () => import('@/views/orderCenter/logisticsOrders/components/trackQuery/trackQuery')
  },
  mixins: [estimateTableHeight],
  data() {
    return {
      queryForm: {
        pageSize: 10,
        pageNumber: 1,
        params: {
          createTime: [startDate, endDate],
          customerIds: [],
          merchantCodeList: [],
          orderType: 1,
          orderNo: '',
          testData: 1
        },
        total: 0
      },
      customerList: [],
      commercialList: [],
      tableData: [],
      tableHeaderList: [
        // 订单创建时间
        {
          id: 'orderCreateTime',
          label: this.$t('collectionCenter.orderCreateT'),
          prop: 'orderCreateTime',
          minWidth: 180
        },
        // 运单号
        {
          id: 'waybillNumber',
          label: this.$t('collectionCenter.waybillNumber'),
          prop: 'waybillNumber',
          minWidth: 260
        },
        // 扫描单号
        {
          id: 'scanNumber',
          label: this.$t('collectionCenter.ScanNumber'),
          prop: 'scanNumber',
          minWidth: 260
        },
        // 客户名称
        {
          id: 'customerName',
          label: this.$t('collectionCenter.CustomerName'),
          prop: 'customerName',
          minWidth: 180
        },
        // 商户号
        {
          id: 'merchantCode',
          label: this.$t('collectionCenter.merchantCode'),
          prop: 'merchantCode',
          minWidth: 180
        },
        // 超期次数
        {
          id: 'overdueCount',
          label: this.$t('collectionCenter.OverdueCount'),
          prop: 'overdueCount',
          minWidth: 180
        },
        // 运单状态
        {
          id: 'waybillStatusName',
          label: this.$t('collectionCenter.shipmentStatus'),
          prop: 'waybillStatusName',
          minWidth: 180
        },
        // 最新轨迹时间
        {
          id: 'lastTrackTime',
          label: this.$t('orderCenterCont.TheLatestTraceTime'),
          prop: 'lastTrackTime',
          minWidth: 180
        },
        // 最新轨迹内容
        {
          id: 'lastTrackDescribe',
          label: this.$t('orderCenterCont.zuixinguijineir'),
          prop: 'lastTrackDescribe',
          minWidth: 260
        }
      ],
      showTrajectoryWindow: false,
      queryTrackParam: null,
      trajectoryKey: new Date().getTime()
    };
  },
  created() {
    this.clickSearch();
  },
  methods: {
    // 导出
    exportExcel() {
      const data = this.queryFormData();
      getTrackOverdueExport(data).then((res) => {
        if (res.code === 200) {
          goResourceTaskList();
        }
      });
    },
    // 商户选项下拉展开
    getShanghuVisible(val) {
      if (val) {
        this.getShanghu();
      }
    },
    // 获取商户
    getShanghu(name = '') {
      const data = {
        pageSize: 20,
        pageNumber: 1,
        params: {
          merchantNames: name,
          customerName: [] // this.queryForm.params.customerIds
        }
      };
      apiGetComplaintGetMerchantName(data, false).then((res) => {
        if (res.code === 200) {
          this.commercialList = res.data.records;
        }
      });
    },
    // 客户选项下拉展开
    userOptionVisible(val) {
      if (val) {
        this.getUserOption();
      }
    },
    // 客户名称列表
    getUserOption(username = '') {
      const queryCustomerParam = {
        pageSize: 20,
        pageNumber: 1,
        params: {
          quickSearch: username
        }
      };
      apiCustomerPage(queryCustomerParam, false).then((res) => {
        if (res.code === 200) {
          this.customerList = res.data.records;
        }
      });
    },
    // 查询条件整理
    queryFormData() {
      const { createTime, orderNo, customerIds, merchantCodeList, testData } = this.queryForm.params;
      const formData = {
        createStartDate: '',
        createEndDate: '',
        customerIds,
        merchantCodeList,
        testData,
        waybillNumberList: [],
        scanNumberList: []
      };
      if (Array.isArray(createTime) && createTime.length === 2) {
        formData.createStartDate = createTime[0];
        formData.createEndDate = createTime[1];
      }
      if (orderNo.length > 0) {
        if (this.queryForm.params.orderType === 1) {
          formData.waybillNumberList = orderNo.split(/\r?\n/).map(item => item.replace(/\s+/g, '')).filter(item => Boolean(item));
        } else {
          formData.scanNumberList = orderNo.split(/\r?\n/).map(item => item.replace(/\s+/g, '')).filter(item => Boolean(item));
        }
      } else {
        formData.waybillNumberList = [];
        formData.scanNumberList = [];
      }
      return formData;
    },
    // 搜索
    clickSearch() {
      this.queryForm.pageNumber = 1;
      this.getTableData();
    },
    // 获取列表数据
    getTableData() {
      const data = this.queryFormData();
      if (data.waybillNumberList.length > 2000 || data.scanNumberList.length > 2000) {
        this.$message.error(this.$t('collectionCenter.QueryNumberCannotExceed2000'));
        return;
      }
      const queryParam = {
        pageSize: this.queryForm.pageSize,
        pageNumber: this.queryForm.pageNumber,
        params: this.queryFormData()
      };
      getTrackOverdueList(queryParam).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.queryForm.total = res.data.total;
        }
      });
    },
    // 重置
    resetForm() {
      this.queryForm = {
        pageSize: 10,
        pageNumber: 1,
        params: {
          createTime: [startDate, endDate],
          customerIds: [],
          merchantCodeList: [],
          orderType: 1,
          orderNo: '',
          testData: 1
        },
        total: 0
      };
      this.getTableData();
    },
    // 查询轨迹
    goWaybill(val) {
      this.queryTrackParam = val;
      this.showTrajectoryWindow = true;
      this.trajectoryKey = new Date().getTime();
    },
    // 每页显示数量改变时触发
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.queryForm.pageNumber = 1;
      this.getTableData();
    },
    // 当前页码改变时触发
    handleCurrentChange(val) {
      this.queryForm.pageNumber = val;
      this.getTableData();
    }
  }
};
</script>

<style>
.search-query .el-form-item {
  margin-bottom: 0;
}
.search-query .select-label .el-input__inner,
.search-query .select-label .el-input__icon {
  line-height: 28px;
  height: 28px;
}
.search-query .select-label .el-input__inner {
  border: 0;
  padding: 0;
  font-weight: bold;
}
</style>
